import { useRetailerId } from '../../utils/routing/params.hooks'
import {
  type GetStoreConfigsQueryVariables,
  useGetStoreConfigsQuery,
  useGetStoreConfigsByPartnerIdQuery,
} from '../../__codegen__/api'

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export interface PartialParams extends PartialBy<GetStoreConfigsQueryVariables, 'retailerIds'> {
  throwOnMissing?: boolean
}

export interface Props extends GetStoreConfigsQueryVariables {}

interface QueryOptions {
  skip?: boolean
}

export const useRetailersStoreConfigurations = (props: PartialParams, options?: QueryOptions) => {
  const { throwOnMissing = true } = props
  const retailerId = useRetailerId({ throwOnMissing })
  return useStoreConfigurations({ retailerIds: [retailerId], ...props }, options)
}

export const useStoreConfigurations = (props: Props, options?: QueryOptions) => {
  const vars = {
    ...props,
  }
  const onlyInvalidRetailerId =
    (vars.retailerIds.length == 1 && vars.retailerIds[0] == '0') || vars.retailerIds.length == 0
  return useGetStoreConfigsQuery({
    variables: vars,
    skip: onlyInvalidRetailerId || !!options?.skip,
  })
}

export const useStoreConfigurationsByPartnerId = (
  props: {
    partnerId: string
    storeConfigRelationship: any
  },
  options?: QueryOptions
) => {
  const vars = {
    ...props,
  }
  const invalidPartnerId = props.partnerId === '0' || !props.partnerId
  return useGetStoreConfigsByPartnerIdQuery({
    variables: vars,
    skip: invalidPartnerId || !!options?.skip,
  })
}
